import type { ClientEnvironment } from './types';

export function clientEnvironment(): ClientEnvironment {
  return {
    screen: screenSize(),
    language: browserLanguage(),
    hostname: currentHostname(),
  };
}

function screenSize(): string | null {
  try {
    const { width, height } = window.screen;
    if (!width || !height) return null;
    return `${width}x${height}`;
  } catch {
    return null;
  }
}

function browserLanguage(): string | null {
  try {
    return navigator.language || null;
  } catch {
    return null;
  }
}

function currentHostname(): string | null {
  try {
    return window.location.hostname || null;
  } catch {
    return null;
  }
}
